import Chart from 'react-apexcharts'
import { colors } from '../../theme'

export type RadialBarProps = {
  percentageGraphic: number
}

const defaultOptions: ApexCharts.ApexOptions = {
  fill: { colors: [colors.secondary] },
  grid: { padding: { top: 0, left: 0, right: 0, bottom: 0 } },
  chart: {
    width: 70,
    height: 70,
    sparkline: {
      enabled: true,
    },
  },
  plotOptions: {
    radialBar: {
      hollow: { size: '45%' },
      track: { background: `${colors.trackGrafico}` },
      dataLabels: {
        name: { show: false },
        value: {
          offsetY: 5,
          fontSize: '12px',
          color: `${colors.white}`,
          fontWeight: 'bold',
        },
      },
    },
  },
}

export function RadialBarDasboard({ percentageGraphic }: RadialBarProps) {
  return (
    <Chart
      width={70}
      height={70}
      series={[percentageGraphic]}
      options={defaultOptions}
      type="radialBar"
    />
  )
}
